import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import React from "react";
import NoDataBoxStyles from "../styles/NoDataBox.styles";

const NoDataBox = () => {
	const classes = NoDataBoxStyles();
	return (
		<Box className={classes.noDataBox}>
			<Typography className={classes.noData} variant="caption">
				No Data Available
			</Typography>
		</Box>
	);
};

export default NoDataBox;
